import React, { createContext, useContext, useState } from "react";

const LoaderContext = createContext();

export const LoaderProvider = ({ children }) => {
  const [isLoading, setIsLoading] = useState(false);

  const loaderStart = () => setIsLoading(true);
  const loaderClose = () => setIsLoading(false);

  return (
    <LoaderContext.Provider value={{ isLoading, loaderStart, loaderClose }}>
      {children}
    </LoaderContext.Provider>
  );
};

export const useLoader = () => useContext(LoaderContext);